// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import globalVariable from '@/api/global_variable.js'
import {getDate} from './api/getDate.js'
//vant有赞引入
import { Button,Col, Row,Form,Field,picker,popup,calendar,DatetimePicker,RadioGroup,Radio,Dialog,Area,checkbox,Switch,Cell,CellGroup,List,Toast,Uploader  } from 'vant';

Vue.config.productionTip = false
Vue.prototype.$ajax = axios
Vue.prototype.GLOBAL = globalVariable
Vue.prototype.getDate=getDate;
//vant有赞引入
Vue.use(Button);
Vue.use(Col);
Vue.use(Row);
Vue.use(Form);
Vue.use(Field);
Vue.use(picker);
Vue.use(popup);
Vue.use(calendar);
Vue.use(DatetimePicker);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Dialog);
Vue.use(Area);
Vue.use(checkbox);
Vue.use(Switch);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(List);
Vue.use(Toast);
Vue.use(Uploader);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  // methods: {
    // submitForm () {
    //   this.$ajax({
    //     method: 'post',
    //     url: '/user',
    //     data: {
    //       name: 'wise',
    //       info: 'wrong'
    //     }
    //   })
    // }}
})



// WEBPACK FOOTER //
// ./src/main.js